export default __webpack_public_path__ + "static/media/ArrowUp.55a4797d.svg";